import "react-circular-progressbar/dist/styles.css"
import "./CircularTimer.scss"

import React, { useEffect, useState } from "react"

// eslint-disable-next-line import/no-cycle
import { LINKEDIN_ACCOUNT_GLOBAL_STATUS } from "../../../constants/account-statuses"
import LangText from "../LangText"

const CircularTimer = props => {
  const {
    // loading,
    status = {},
    updateValue = () => {},
    executionSeconds = 0,
    executionMinutes = 0,
    pinTimestamp = false,
    timeIsUp = false,
    executionTime = 0,
  } = props
  const [seconds, setSeconds] = useState(0)
  const [decrementedSeconds, setDecrementedSeconds] = useState(executionSeconds || {})
  const [minutes, setMinutes] = useState(executionMinutes || {})
  // const [percentage, setPercentage] = useState(0)
  const [loader, setLoader] = useState(0)
  const [timeoutIteration, setTimeoutIteration] = useState(true)

  useEffect(() => {
    if (executionSeconds !== null && executionMinutes !== null) {
      if (
        status.progressBar !== LINKEDIN_ACCOUNT_GLOBAL_STATUS.TIMES_UP_CUSTOM_STATUS &&
        pinTimestamp &&
        executionSeconds &&
        executionMinutes
      ) {
        setMinutes(executionMinutes)
        setDecrementedSeconds(executionSeconds * 1000)
        setSeconds(executionSeconds)
      } else {
        // case if doesn't have pinTimestamp
        setMinutes("0")
        setSeconds("0")
        updateValue(LINKEDIN_ACCOUNT_GLOBAL_STATUS.TIMES_UP_CUSTOM_STATUS)
      }
    }
  }, [executionMinutes, executionSeconds, pinTimestamp, timeIsUp])

  const updateTime = () => {
    if (timeoutIteration) {
      setDecrementedSeconds(decrementedSeconds - 1)

      if (loader === 0) {
        setLoader(100)
      } else {
        setLoader(0)
      }

      if (pinTimestamp && executionSeconds && executionMinutes) {
        if ((minutes === 0 && seconds === 0) || minutes < 0) {
          // reset
          updateValue(LINKEDIN_ACCOUNT_GLOBAL_STATUS.TIMES_UP_CUSTOM_STATUS)
          setTimeoutIteration(false)
        } else if (seconds === 0) {
          setMinutes(minutes - 1)
          setSeconds(59)
        } else {
          setSeconds(seconds - 1)
        }
      }
    }
  }

  useEffect(() => {
    const timer = setTimeout(updateTime, 1000)

    return function cleanUp() {
      clearTimeout(timer)
    }
  }, [
    updateTime,
    decrementedSeconds,
    minutes,
    seconds,
    executionSeconds,
    executionMinutes,
    executionTime,
  ])

  const currentMinutes =
    minutes < 10 ||
    minutes === 0 ||
    (typeof minutes === "object" && Object.keys(minutes).length === 0)
      ? `00`
      : minutes
  const currentSeconds = !seconds || seconds < 10 || seconds === 0 ? `0${seconds}` : seconds

  return (
    <div className="timer-wrapper">
      <LangText langKey="label.expires-in" /> {`${currentMinutes}:${currentSeconds}`}
    </div>
  )
}

// CircularTimer.propTypes = {
//   // loading: PropTypes.number,
//   status: PropTypes.shape({ progressBar: PropTypes.number }),
//   updateValue: PropTypes.func,
//   executionSeconds: PropTypes.number,
//   executionMinutes: PropTypes.number,
//   pinTimestamp: PropTypes.bool,
//   timeIsUp: PropTypes.bool,
//   executionTime: PropTypes.number,
// }

export default CircularTimer
